<template>
  <div class="row">
    <div class="col-md-12" v-for="url in urls">
      <div class="box box-primary">
        <div class="overlay" v-if="url.loading">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">{{ url.title }}</h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getAvertissement(url.url)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover table-responsive"
                 v-if="['recapitulatifsEnAttentePayement'].includes(url.url)">
            <thead>
            <tr>
              <th>Date</th>
              <th>Numéro récapitulatif</th>
              <th>Club</th>
              <th>Nombre de membres</th>
              <th>Statut</th>
              <th>Total</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="result in url.result">
              <td>
                {{ result.date }}
              </td>
              <td>
                <router-link :to="{ name: 'Recap', params: { recap_id: result.id }}">
                  Récapitulatif {{ result.id | idFormat }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'Club', params: { club_id: result.club.id }}">
                  {{ result.club.club }}
                </router-link>
              </td>

              <td>
                {{ result.licences.length }}
                {{ result.licences.length > 1 ? " membres" : " membre" }}
              </td>
              <td>
                <span
                  :class="getClassNameRecap(result.statut.type)">
                                    {{ result.statut.type }}
                                </span>
              </td>
              <td>{{ result.total | idFormat }}€</td>

            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

var _ = require('underscore')

var moment = require('moment')

export default {
  data() {
    return {
      urls: {
        recapitulatifsEnAttentePayement: {
          loading: false,
          url: "recapitulatifsEnAttentePayement",
          // param: moment().year(),
          title: "Récapitulatifs en attente de payement",
          result: [],
        },

      },

    }
  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
    }),

  },
  mounted: function () {
    _.each(this.urls, item => {
      this.getAvertissement(item);
    })
    // this.urls.forEach(item => {
    //     this.getAvertissement(item.url);
    // })
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
    }),
    getClassNameRecap: function (statut) {
      return this.$getClassNameRecap(statut)
    },
    containsUrls: function (url, arrayUrls) {
      // return arrayUrls.includes(url)
    },
    getAvertissement: function (item) {
      let self = this;
      this.urls[item.url].loading = true
      self.$http.get(this.getRoute('Avertissement.' + item.url) + (item.param != null ? item.param : "")).then((response) => {
        this.urls[item.url].result = response.body
        this.urls[item.url].loading = false
      }, (response) => {
        console.log(response)
      });
    },

  },
  beforeRouteUpdate(to, from, next) {
  },

  beforeRouteEnter(to, from, next) {
  },
  watch: {},
  components: {},
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Avertissement/Avertissement_recapitulatif.vue